// Datos SISS de dureza por comuna. Separado para poder actualizarlo solo.
window.NAIRE_COMUNAS = {
    "Alhué":{"dureza":200,"nivel":"Moderada"},
    "Buin":{"dureza":300,"nivel":"Dura"},
    "Calera de Tango":{"dureza":600,"nivel":"Muy dura"},
    "Cerrillos":{"dureza":620,"nivel":"Muy dura"},
    "Cerro Navia":{"dureza":490,"nivel":"Dura"},
    "Colina":{"dureza":650,"nivel":"Muy dura"},
    "Conchalí":{"dureza":460,"nivel":"Dura"},
    "Curacaví":{"dureza":250,"nivel":"Moderada"},
    "El Bosque":{"dureza":380,"nivel":"Dura"},
    "El Monte":{"dureza":255,"nivel":"Moderada"},
    "Estación Central":{"dureza":470,"nivel":"Dura"},
    "Huechuraba":{"dureza":690,"nivel":"Muy dura"},
    "Independencia":{"dureza":450,"nivel":"Dura"},
    "Isla de Maipo":{"dureza":245,"nivel":"Moderada"},
    "La Cisterna":{"dureza":370,"nivel":"Dura"},
    "La Florida":{"dureza":270,"nivel":"Moderada"},
    "La Granja":{"dureza":400,"nivel":"Dura"},
    "La Pintana":{"dureza":390,"nivel":"Dura"},
    "La Reina":{"dureza":510,"nivel":"Muy dura"},
    "Lampa":{"dureza":500,"nivel":"Muy dura"},
    "Las Condes":{"dureza":330,"nivel":"Dura"},
    "Lo Barnechea":{"dureza":220,"nivel":"Moderada"},
    "Lo Espejo":{"dureza":430,"nivel":"Dura"},
    "Lo Prado":{"dureza":480,"nivel":"Dura"},
    "Macul":{"dureza":340,"nivel":"Dura"},
    "Maipú":{"dureza":590,"nivel":"Muy dura"},
    "Melipilla":{"dureza":230,"nivel":"Moderada"},
    "Ñuñoa":{"dureza":280,"nivel":"Moderada"},
    "Padre Hurtado":{"dureza":600,"nivel":"Muy dura"},
    "Paine":{"dureza":300,"nivel":"Dura"},
    "Pedro Aguirre Cerda":{"dureza":420,"nivel":"Dura"},
    "Peñaflor":{"dureza":260,"nivel":"Moderada"},
    "Peñalolén":{"dureza":300,"nivel":"Dura"},
    "Pirque":{"dureza":240,"nivel":"Moderada"},
    "Providencia":{"dureza":310,"nivel":"Dura"},
    "Pudahuel":{"dureza":540,"nivel":"Muy dura"},
    "Puente Alto":{"dureza":520,"nivel":"Muy dura"},
    "Quilicura":{"dureza":300,"nivel":"Dura"},
    "Quinta Normal":{"dureza":600,"nivel":"Muy dura"},
    "Recoleta":{"dureza":440,"nivel":"Dura"},
    "Renca":{"dureza":560,"nivel":"Muy dura"},
    "San Bernardo":{"dureza":530,"nivel":"Muy dura"},
    "San Joaquín":{"dureza":360,"nivel":"Dura"},
    "San José de Maipo":{"dureza":600,"nivel":"Muy dura"},
    "San Miguel":{"dureza":350,"nivel":"Dura"},
    "San Ramón":{"dureza":410,"nivel":"Dura"},
    "Santiago":{"dureza":320,"nivel":"Dura"},
    "Talagante":{"dureza":260,"nivel":"Moderada"},
    "Til Til":{"dureza":700,"nivel":"Muy dura"},
    "Vitacura":{"dureza":210,"nivel":"Moderada"},
    "Iquique":{"dureza":400,"nivel":"Muy dura"},
    "Alto Hospicio":{"dureza":400,"nivel":"Muy dura"},
    "Pozo Almonte":{"dureza":600,"nivel":"Muy dura"},
    "Arica":{"dureza":500,"nivel":"Muy dura"},
    "Antofagasta":{"dureza":350,"nivel":"Dura"},
    "Calama":{"dureza":400,"nivel":"Muy dura"},
    "Tocopilla":{"dureza":300,"nivel":"Dura"},
    "Copiapó":{"dureza":850,"nivel":"Muy dura"},
    "Caldera":{"dureza":700,"nivel":"Muy dura"},
    "Vallañar":{"dureza":500,"nivel":"Muy dura"},
    "La Serena":{"dureza":280,"nivel":"Moderada"},
    "Coquimbo":{"dureza":280,"nivel":"Moderada"},
    "Ovalle":{"dureza":300,"nivel":"Dura"},
    "Illapel":{"dureza":280,"nivel":"Moderada"},
    "Los Vilos":{"dureza":260,"nivel":"Moderada"},
    "Valparaíso":{"dureza":200,"nivel":"Moderada"},
    "Viña del Mar":{"dureza":200,"nivel":"Moderada"},
    "Quilpué":{"dureza":210,"nivel":"Moderada"},
    "Villa Alemana":{"dureza":210,"nivel":"Moderada"},
    "San Antonio":{"dureza":190,"nivel":"Moderada"},
    "Los Andes":{"dureza":230,"nivel":"Moderada"},
    "San Felipe":{"dureza":230,"nivel":"Moderada"},
    "Quillota":{"dureza":210,"nivel":"Moderada"},
    "Rancagua":{"dureza":180,"nivel":"Moderada"},
    "San Fernando":{"dureza":160,"nivel":"Moderada"},
    "Pichilemu":{"dureza":140,"nivel":"Blanda"},
    "Talca":{"dureza":130,"nivel":"Blanda"},
    "Curicó":{"dureza":130,"nivel":"Blanda"},
    "Linares":{"dureza":130,"nivel":"Blanda"},
    "Constitución":{"dureza":110,"nivel":"Blanda"},
    "Concepción":{"dureza":100,"nivel":"Blanda"},
    "Talcahuano":{"dureza":100,"nivel":"Blanda"},
    "Coronel":{"dureza":90,"nivel":"Blanda"},
    "Lota":{"dureza":90,"nivel":"Blanda"},
    "Tomé":{"dureza":100,"nivel":"Blanda"},
    "Hualpén":{"dureza":100,"nivel":"Blanda"},
    "Los Ángeles":{"dureza":110,"nivel":"Blanda"},
    "Chillán":{"dureza":120,"nivel":"Blanda"},
    "Temuco":{"dureza":80,"nivel":"Blanda"},
    "Villarrica":{"dureza":70,"nivel":"Blanda"},
    "Pucón":{"dureza":60,"nivel":"Blanda"},
    "Angol":{"dureza":90,"nivel":"Blanda"},
    "Valdivia":{"dureza":70,"nivel":"Blanda"},
    "La Unión":{"dureza":70,"nivel":"Blanda"},
    "Panguipulli":{"dureza":60,"nivel":"Blanda"},
    "Puerto Montt":{"dureza":80,"nivel":"Blanda"},
    "Puerto Varas":{"dureza":70,"nivel":"Blanda"},
    "Castro":{"dureza":70,"nivel":"Blanda"},
    "Osorno":{"dureza":80,"nivel":"Blanda"},
    "Ancud":{"dureza":70,"nivel":"Blanda"},
    "Coyhaique":{"dureza":40,"nivel":"Blanda"},
    "Punta Arenas":{"dureza":70,"nivel":"Blanda"}
  };
